import React, { useEffect, useState } from "react";
import SecondaryButton from "../common/buttons/SecondaryButton";
import DownSelectIcon from "../../assets/icons/down-select-icon";

const MoveTo = ({
  isOpen,
  onClose,
  onMove,
  addToast,
  selectedStatus,
  statusOptions = [],
  selectedCount = 0,
  trialId = "",
  isDisable = false,
}) => {
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const normalizedSelectedStatus = String(selectedStatus || "")
    .toLowerCase()
    .replace(/[\s-]+/g, "");

  const filteredStatusOptions = (() => {
    if (normalizedSelectedStatus === "tocall") {
      return statusOptions.filter((status) =>
        ["ContactAttempt1", "ContactAttempt2", "ContactAttempt3"].includes(
          status?.normalizedStatus
        )
      );
    }

    if (
      ["contactattempt1"].includes(
        normalizedSelectedStatus
      )
    ) {
      return statusOptions.filter((status) =>
        ["ContactAttempt2", "ContactAttempt3", "DNQNoResponse"].includes(
          status?.normalizedStatus
        )
      );
    }

    if (
      ["contactattempt2"].includes(
        normalizedSelectedStatus
      )
    ) {
      return statusOptions.filter((status) =>
        ["ContactAttempt3", "DNQNoResponse"].includes(
          status?.normalizedStatus
        )
      );
    }

    if (
      ["contactattempt3"].includes(
        normalizedSelectedStatus
      )
    ) {
      return statusOptions.filter(
        (status) => status?.normalizedStatus === "DNQNoResponse"
      );
    }

    return statusOptions;
  })();

  useEffect(() => {
    if (!isOpen) return;
    setSelectedStatusId("");
    setMessage("");
  }, [isOpen, trialId]);

  if (!isOpen) return null;

  const handleMove = async () => {
    if (isDisable) {
      return;
    }

    if (!selectedStatusId) {
      addToast?.("Please select a status.", "error");
      return;
    }

    if (typeof onMove !== "function") {
      addToast?.("No status update handler provided.", "error");
      return;
    }

    setIsLoading(true);
    await onMove({ selectedStatusId, message });
    setIsLoading(false);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[602px] rounded-[16px] bg-white p-8 shadow-[0_18px_60px_rgba(15,23,42,0.18)]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-[20px] font-[500] text-[#1F2937]">Move To</h2>

        <div className="mt-8">
          <label className="block text-[16px] font-[500] text-[#1F2937]">
            Status
          </label>

          <div className="relative mt-3">
            <select
              value={selectedStatusId}
              onChange={(e) => {
                if (isDisable) return;
                setSelectedStatusId(e.target.value);
              }}
              disabled={isDisable || isLoading}
              className={`border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none bg-white ${isDisable || isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
            >
              <option value="">Select Status</option>
              {filteredStatusOptions
                .map((status) => (
                  <option key={status.statusID} value={status.statusID}>
                    {status.statusName}
                  </option>
                ))}
            </select>

            <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#6B46C1]">
              <DownSelectIcon />
            </span>
          </div>
        </div>

        <div className="mt-5">
          <textarea
            value={message}
            onChange={(e) => {
              if (isDisable) return;
              setMessage(e.target.value.slice(0, 500));
            }}
            placeholder="Write your message here..."
            disabled={isDisable || isLoading}
            className={`h-[142px] w-full rounded-lg border border_color p-4 text-base text-[#1F2937] outline-none ${isDisable || isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
          />
          <div className="mt-2 text-[13px] text-[#4B5563]">
            {message.length}/500
          </div>
        </div>

        <div className="flex flex-row justify-end gap-5 mt-5">
          <button
            type="button"
            onClick={handleMove}
            disabled={isLoading || isDisable}
            className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? <div className="mini-spinner"></div> : "Move"}
          </button>
          <SecondaryButton
            onClick={onClose}
            label="Cancel"
          />
        </div>
      </div>
    </div>
  );
};

export default MoveTo;
